// @flow

export const number = /^\d+$/;
export const nonEmpty = /.*\S.*/;
export const phoneNumber = /^0?\d{10}?$/;

export const houseNumberOrName = /^.{1,45}$/;

export const day = /^(0[123456789]|[12]\d|3[01])$/;
export const month = /^(0[123456789]|1[012])$/;
export const year = /^(19|20)\d{2}$/;

const emailRegex = /^([^@\s]+)@((?:[-A-Za-z0-9]+\.)+[A-Za-z]{2,})$/;

export const isFcEmail = (value: string): boolean =>
  /fundingcircle\.com$/i.test(value);

export const email = (value: string) =>
  !isFcEmail(value) && value.length <= 80 && emailRegex.test(value);

export const loanAmount = (value: string): boolean =>
  parseInt(value, 10) >= 10000 && parseInt(value, 10) <= 500000;

export const increasedLoanAmount = (value: string): boolean =>
  parseInt(value, 10) >= 10000 && parseInt(value, 10) <= 750000;

export const firstName = (value: string): boolean =>
  value.length >= 2 && value.length <= 30;

export const lastName = (value: string): boolean =>
  value.length >= 2 && value.length <= 50;

export const noTrailingWhitespace = (value: string) => /^.*\S$/.test(value);

export const noLeadingWhitespace = (value: string) => /^\S.*$/.test(value);

export const securePassword = (password: string) =>
  // eslint-disable-next-line no-useless-escape
  /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\\,\>\<\'\:\;\|\_\~\`\=\+\-])(.{12,})$/.test(
    password
  );

// Regular expression taken from
// https://en.wikipedia.org/wiki/Postcodes_in_the_United_Kingdom#Validation
// also used in originations-api
// https://github.com/FundingCircle/originations-api/blob/master/app/models/submitted_actions/executive_business_owner.rb#L7
export const postcode = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i;

export const nonNegativeInteger = (value: string): boolean =>
  Number.isInteger(parseInt(value, 10)) && parseInt(value, 10) >= 0;
